<section class="section_wrapper">
    <h1 id="imprintUp">Imprint</h1>
    <br>
    <h3>Information pursuant to § 5 TMG:</h3>
    <br>
    <h4>Responsible for the content:</h4>
    <br>
    <p>Catalina Acosta Rivera</p>
    <p>Example Street 1</p>
    <p>12345 Example City</p>
    <p>Email: catalina.acosta.rivera&#64;gmail.com</p>
    <br>
    <p>Caryen Song</p>
    <p>Sample Way 2</p>
    <p>12345 Sample City</p>
    <p>Email: caryensong&#64;googlemail.com</p>
    <br>
    <p>Albina Januzi</p>
    <p>Sample Avenue 3</p>
    <p>67890 Sample Town</p>
    <p>Email: albina_januzi&#64;hotmail.com</p>
    <br>
    <p>Barbora Lambeinova</p>
    <p>Market Square 12</p>
    <p>86650 Wemding</p>
    <p>Email: lambeinovab&#64;seznam.cz</p>
    <br>
    <h4>Disclaimer:</h4>
    <br>
    <p>The contents of this app have been created with the greatest possible care. However, we do not guarantee the accuracy, completeness, or timeliness of the content. As a service provider, we are responsible for our own content on this app in accordance with § 7 para. 1 TMG under general law. However, according to §§ 8 to 10 TMG, we are not obligated as a service provider to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.</p>
    <br>
    <h4>Copyright:</h4>
    <br>
    <p>The content published on this app is subject to German copyright law. The reproduction, editing, distribution, and any kind of use beyond the limits of copyright law require the written consent of the respective author or creator.</p>
    <br>
    <h4>Privacy Policy:</h4>
    <br>
    <p>Please also refer to our <a [routerLink]="['/privacy-policy']">Privacy Policy</a>
        .</p>
</section>
